<template>
  <div class="provider-category">
    <span :class="['icon', iconName]" />
    <span class="name">
      {{ category.name }}
    </span>
  </div>
</template>

<script>

const NAME_MAP = {
  2: 'standard',
  3: 'business',
  4: 'premium',
  5: 'economy',
};

export default {
  name: 'ProviderCategory',
  props: {
    category: {
      type: Object,
      default: () => ({
        name: '',
        id: '',
      }),
    },
  },
  computed: {
    iconName() {
      return `icon-${NAME_MAP[this.category.id]}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  .provider-category {
    display: inline-block;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    line-height: 24px;
    color: #444;
    border: 1px solid #5cb66d;
    position: relative;
    height: 24px;
    border-left: 24px solid #5cb66d;
    vertical-align: super;
    margin-top: 16px;
  }

  .icon {
    width: 24px;
    height: 100%;
    display: inline-block;
    position: absolute;
    left: -24px;
    background-repeat: no-repeat;
    background-position: center;
  }

  .icon-standard {
    background-image: url('../../../assets/svg/icon_standard.svg');
  }

  .icon-premium {
    background-image: url('../../../assets/svg/icon_premium.svg');
  }

  .icon-economy {
    background-image: url('../../../assets/svg/icon_economy.svg');
  }

  .icon-business {
    background-image: url('../../../assets/svg/icon_business.svg');
  }

  .name {
    padding: 0 7px;
  }
</style>
